import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useT } from "@/i18n_extra";
import { CITIES } from "@/data/cities";

export const ServiceArea = () => {
  const t = useT();
  return (
    <section id="areas" className="relative py-28 sm:py-36 bg-[#FAF9F6]" data-testid="service-area-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#D4AF37]">{t.areas.label}</span>
          </div>
          <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl leading-[1.05]">{t.areas.title}</h2>
          <p className="mt-6 text-black/65 text-base sm:text-lg leading-relaxed">{t.areas.sub}</p>
        </motion.div>

        <div className="mt-14 flex flex-wrap gap-3" data-testid="cities-grid">
          {CITIES.map((city, i) => (
            <motion.span
              key={city.slug}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.03 }}
            >
              <Link
                to={`/windshield-replacement-${city.slug}`}
                data-testid={`city-chip-${city.slug}`}
                className="inline-block px-5 py-2.5 rounded-full border border-black/10 text-sm font-medium text-black/60 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-300"
              >
                {city.name}
              </Link>
            </motion.span>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-10 text-sm text-black/40 italic"
        >
          {t.areas.note}
        </motion.p>
      </div>
    </section>
  );
};
